import { createContext } from 'react';

export const ModifyContext = createContext();
export const ReadOnlyContext = createContext();
